import script from "./PayQrcodeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PayQrcodeDialog.vue?vue&type=script&setup=true&lang=js"

import "./PayQrcodeDialog.vue?vue&type=style&index=0&id=180f7087&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180f7087"]])

export default __exports__